export default __webpack_public_path__ + "static/selfapp-536-5350102842e791228b44e87d0e171c66.jpg";